/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import loadingConfig from "../config/loading.config.json";
import headerConfig2025 from "../config/header2025.config.json";
import headerConfig from "../config/header.config.json";
import errorConfig from "../config/error.config.json";
import paymentFrom from "../config/paymentForm.config.json";
import paymentNewFrom from "../config/paymentNewForm.config.json";
import notificationConfig from "../config/notifications.config.json";
import deleteBoxConfig from "../config/deleteBox.config.json";
import updateValidEmailIDConfig from "../config/updateValidEmailID.config.json";
import delegateName from "../config/delegateName.config.json";
import changeMode from "../config/changeMode.config.json";
import adjustment from "../config/adjustment.config.json";
import transferBox from "../config/transferBox.config.json";
import addBoxNoteConfig from "../config/addBoxNote.config.json";
import paymentSummaryConfig from "../config/paymentSummary.config.json";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      header2025: { ...headerConfig },
      header: { ...headerConfig2025 },
      loading: loadingConfig,
      error: errorConfig,
      payMethodForm: paymentFrom,
      payNewMethodForm: paymentNewFrom,
      notifications: notificationConfig,
      delegateName: delegateName,
      changeMode: changeMode,
      deleteBox: deleteBoxConfig,
      adjustment: adjustment,
      transferBox: transferBox,
      updateValidEmailID: updateValidEmailIDConfig,
      addBoxNote: addBoxNoteConfig,
      paymentSummaryConfig: paymentSummaryConfig,
    };
  }
}
